import updateDocumentData from "../../utils/updateDocumentData";

import { Studio } from "./types/Studio";

export default function updateStudio(firebase, ref, data) {
	const studioData = Studio.partial().parse(updateDocumentData(firebase, data));

	return ref.set(studioData, { merge: true });
}
